class Logger {
  private static formatLog(
    level: string,
    message: string,
    context?: any
  ): string {
    const timestamp = new Date().toISOString();
    const contextInfo = context ? ` | Context: ${JSON.stringify(context)}` : "";
    return `[${timestamp}] [${level.toUpperCase()}]: ${message}${contextInfo}`;
  }

  static info(message: string, context?: any): void {
    console.log(
      `%c${this.formatLog("info", message, context)}`,
      "color: green; font-weight: bold"
    );
  }

  static warn(message: string, context?: any): void {
    console.warn(
      `%c${this.formatLog("warn", message, context)}`,
      "color: orange; font-weight: bold"
    );
  }

  static error(message: string, context?: any): void {
    console.error(
      `%c${this.formatLog("error", message, context)}`,
      "color: red; font-weight: bold"
    );
  }

  static debug(message: string, context?: any): void {
    console.debug(
      `%c${this.formatLog("debug", message, context)}`,
      "color: blue; font-weight: bold"
    );
  }

  static trace(message: string, context?: any): void {
    console.trace(
      `%c${this.formatLog("trace", message, context)}`,
      "color: purple; font-weight: bold"
    );
  }
}

export default Logger;
